import { Facebook, Instagram, Linkedin, Youtube, Phone, MapPin, Mail } from "lucide-react";
import { LOGO_URL } from "@/lib/assets";

const COL_NAV = [
  { title: "Probate", links: ["Probate or No Probate", "Executor Duties", "Sell An Estate", "Free Package", "Probate E-Book"] },
  { title: "Real Estate", links: ["Find Your Home", "What's My Home Worth", "Mortgage Calculator", "Market Your Home", "Featured Listings"] },
  { title: "Company", links: ["About Us", "Our Team", "Referral Services", "Testimonials", "Contact Us"] },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-navy-900 text-white pt-20 pb-10 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04]" style={{
        backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
        backgroundSize: "32px 32px",
      }} />
      <div className="absolute -top-32 left-1/3 h-96 w-96 rounded-full bg-gold-500/10 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Columns */}
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <a href="#home" className="flex items-center gap-3">
              <div className="h-12 w-12 rounded-xl bg-white/95 p-1.5 flex items-center justify-center">
                <img src={LOGO_URL} alt="Probate Solution OC" className="h-full w-full object-contain" />
              </div>
              <div className="leading-tight">
                <div className="font-heading text-lg text-white">Probate Solution OC</div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-gold-400">Your Success · Our Success</div>
              </div>
            </a>
            <p className="mt-5 text-sm text-white/65 leading-relaxed max-w-sm">
              A boutique probate real estate practice anchored in integrity,
              compassion, and care. Serving Orange County families with a
              national referral network behind us.
            </p>

            <div className="mt-6 space-y-2.5 text-sm text-white/70">
              <div className="flex items-center gap-2.5"><MapPin size={14} className="text-gold-400" /> 2134 Main St. Suite 140, Huntington Beach, CA 92648</div>
              <div className="flex items-center gap-2.5"><Phone size={14} className="text-gold-400" /> <a href="tel:+17143913645" className="hover:text-gold-400">(714) 391-3645</a></div>
              <div className="flex items-center gap-2.5"><Mail size={14} className="text-gold-400" /> marynguyenrealtor@gmail.com</div>
            </div>

            <div className="mt-6 flex items-center gap-2">
              {[Facebook, Instagram, Linkedin, Youtube].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`social-${i}`}
                  className="h-9 w-9 rounded-full border border-white/15 flex items-center justify-center text-white/70 hover:bg-gold-500 hover:text-navy-900 hover:border-gold-500 transition-all"
                >
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>

          {COL_NAV.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <div className="text-[10px] uppercase tracking-[0.3em] text-gold-400 font-semibold">{col.title}</div>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l}>
                    <a href="#" className="text-sm text-white/70 hover:text-gold-400 transition-colors">{l}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.3em] text-gold-400 font-semibold">Compliance</div>
            <ul className="mt-4 space-y-2.5">
              {["Privacy Policy", "Terms of Service", "DRE License #01234567", "Fair Housing", "Accessibility"].map((l) => (
                <li key={l}><a href="#" className="text-sm text-white/70 hover:text-gold-400 transition-colors">{l}</a></li>
              ))}
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-14 rounded-2xl border border-white/10 bg-white/[0.03] p-5 text-xs text-white/55 leading-relaxed" data-testid="disclaimer">
          <span className="text-gold-400 font-semibold">Disclaimer · </span>
          The purpose of this website is to provide general information on the legal terminologies and probate process, which is subject to change, and the services that ProbateSolutionOC can offer. It is not intended as a substitute for legal advice. If you have legal questions, you should consult an attorney.
        </div>

        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Probate Solution OC. All rights reserved.</div>
          <div className="flex items-center gap-1.5 flex-wrap justify-center">
            <span>Proudly serving Garden Grove &amp; Orange County ·</span>
            <a
              href="https://ggcity.org/hr"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="garden-grove-link"
              className="text-white/70 hover:text-gold-400 underline underline-offset-2 transition-colors"
            >
              City of Garden Grove
            </a>
            <span>·</span>
            <a
              href="https://www.marynguyenhomes.com/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mary-nguyen-homes-link"
              className="text-white/70 hover:text-gold-400 underline underline-offset-2 transition-colors"
            >
              Mary Nguyen Homes
            </a>
          </div>
          <div>Crafted with compassion in Huntington Beach, California.</div>
        </div>
      </div>
    </footer>
  );
}
